export function getCustomerRequestStatus(problem = {}) {
  if (problem.status === "completed") {
    return { label: "Afsluttet", tone: "neutral" };
  }
  if (problem.status === "cancelled") {
    return { label: "Annulleret", tone: "danger" };
  }
  if (problem.status === "offer_accepted" || problem.status === "accepted" || problem.status === "booked") {
    if (problem.payment_status !== "paid") {
      return { label: "Afventer betaling", tone: "attention" };
    }
    if (problem.consultation_schedule_state !== "confirmed" || !problem.scheduled_at) {
      return { label: "Aftal tidspunkt", tone: "attention" };
    }
    return { label: "Samtale aftalt", tone: "success" };
  }
  if (problem.clarification_unanswered) {
    return { label: "Ekspert har et spørgsmål", tone: "attention" };
  }
  if ((problem.proposal_count || 0) > 0 || problem.status === "offer_received") {
    return { label: "Nyt prisforslag", tone: "success" };
  }
  return { label: "Afventer svar fra eksperter", tone: "waiting" };
}

export const REQUEST_STATUS_CLASSES = {
  neutral: "bg-brand-soft text-brand-muted border-brand-line",
  danger: "bg-[#F7E4E4] text-[#991B1B] border-[#E9C9C9]",
  success: "bg-brand-soft text-[#166534] border-brand-line-strong",
  attention: "bg-[#FDF3EA] text-[#B0561D] border-[#F3D9C1]",
  waiting: "bg-brand-soft text-brand-body border-brand-line",
};

